import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { CheckoutFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPayPOSTErrorResponse, ParkPayPOSTRequest, ParkPayPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchPay = async (data: ParkPayPOSTRequest): Promise<ParkPayPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPayPOSTSuccessResponse>("/pay", data);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPayPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: CheckoutFailReason };
  }
};
